import { api } from '@/lib/api'
import type { ExternalAsset, ExternalAssetCreate, ExternalAssetUpdate } from '@/types/externalAsset'

export async function listExternalAssets(): Promise<ExternalAsset[]> {
  const { data } = await api.get<ExternalAsset[]>('/external-assets/')
  return data
}

export async function createExternalAsset(body: ExternalAssetCreate): Promise<ExternalAsset> {
  const { data } = await api.post<ExternalAsset>('/external-assets/', body)
  return data
}

export async function updateExternalAsset(
  id: number,
  body: ExternalAssetUpdate,
): Promise<ExternalAsset> {
  const { data } = await api.patch<ExternalAsset>(`/external-assets/${id}`, body)
  return data
}

export async function deleteExternalAsset(id: number): Promise<void> {
  await api.delete(`/external-assets/${id}`)
}
